module.exports = __webpack_public_path__ + "img/f6.bc2fdb99.png";